module.exports = __webpack_public_path__ + "img/8.3afcc1c9.png";